"use strict";

/**
 * Created by jcrid01 on 1/5/16.
 */
module.exports = {
    getLocaleDropdownData: function getLocaleDropdownData(getLocalizedText) {
        return [{
            label: getLocalizedText("language_select_english"),
            value: "en_US"
        }, {
            label: getLocalizedText("language_select_canadian_english"),
            value: "en_CA"
        }, {
            label: getLocalizedText("language_select_canadian_french"),
            value: "fr_CA"
        }, {
            label: getLocalizedText("language_select_spanish"),
            value: "es_US"
        }];
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/data/locale.js
// module id = 896
// module chunks = 0